<template>
    <div class="lime-body">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-separator-1">
                            <!--<li class="breadcrumb-item"><a href="#">Pages</a></li>-->
                            <li class="breadcrumb-item active" aria-current="page">User Profile</li>
                        </ol>
                    </nav>
                    <div class="page-title">
                        <h3>User Profile</h3>
                        <div class="search-create">
                            <button class="btn btn-secondary">Cancel Subscription</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="card profile">
                        <div class="card-body center">
                            <h5 class="card-title">User Detail</h5>
                            <form>
                                <div class="form-group">
                                    <!--<div class="value">
                                        <label>Email :</label>
                                        <span>buddymckinney@ghostpaid.com</span>
                                    </div>-->
                                    <input class="form-control" type="text" placeholder="Enter Email" />
                                </div>
                                <div class="form-group">
                                    <!--<div class="value">
                                        <label>User Name :</label>
                                        <span>BmcKinney</span>
                                    </div>-->
                                    <input class="form-control" type="text" placeholder="Enter User Name" />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card profile">
                        <div class="card-body">
                            <h5 class="card-title">Bank Detail</h5>
                            <form>
                                <div class="form-group">
                                    <select class="form-control">
                                        <option>Bank Type</option>
                                        <option>Bank Type One</option>
                                        <option>Bank Type Two</option>
                                        <option>Bank Type Three</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <select class="form-control">
                                        <option>Currency Type</option>
                                        <option>Currency Type One</option>
                                        <option>Currency Type Two</option>
                                        <option>Currency Type Three</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <input class="form-control" placeholder="Account Holder Name" />
                                </div>
                                <div class="form-group">
                                    <select class="form-control">
                                        <option>Account Holder Type</option>
                                        <option>Account Holder Type One</option>
                                        <option>Account Holder Type Two</option>
                                        <option>Account Holder Type Three</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <input class="form-control" placeholder="Account Number" />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card profile">
                        <div class="card-body">
                            <h5 class="card-title">Change Password</h5>
                            <form>
                                <div class="form-group">
                                    <input class="form-control" placeholder="Current Password" />
                                </div>
                                <div class="form-group">
                                    <input class="form-control" placeholder="New Password" />
                                </div>
                                <div class="form-group">
                                    <input class="form-control" placeholder="Confirm Password" />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <button class="btn btn-primary">Edit</button>
            <button class="btn btn-secondary">Cancel</button>                 
        </div>
    </div>
</template>

<script>

export default {
  name: 'ProfilePage',
  data () {
    return {
      msg: 'Dashboard'
    }
  },
  methods: {
    logout () {
      localStorage.removeItem('jwt')
      localStorage.removeItem('user')
      this.$router.push('login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProfilePage.vue